import { array, boolean, number, object, string } from "yup";
import {
  ADD_ID,
  CYL_ID,
  SIDE_ID,
  SPH_ID,
} from "../../product-variant-attributes";
import { StatusEnum } from "../../shared";

export const DEFAULT_VALUES = {
  productCategory: null,
  unitOfMeasurement: null,
  status: StatusEnum.ACTIVE,
  productAddOns: [],
  variantAttributes: [
    {
      id: SPH_ID,
      name: "Sph",
      checked: true,
      required: true,
    },
    {
      id: CYL_ID,
      name: "Cyl",
      checked: true,
      required: true,
    },
    {
      id: ADD_ID,
      name: "Add",
      checked: false,
      required: false,
    },
    {
      id: SIDE_ID,
      name: "Sisi",
      checked: false,
      required: false,
    },
  ],
  lensProductVariantGroups: [],
  availableToAllOutlets: false,
  outlets: {},
};

export const VALIDATION_SCHEMA = object().shape({
  name: string().required("Harus diisi"),
  stockKeepingUnitPrefix: string().required("Harus diisi"),
  productCategory: object().required("Harus diisi"),
  unitOfMeasurement: object().required("Harus diisi"),
  status: boolean().required("Harus diisi"),
  lensProductVariantGroups: array().min(1, "Minimal 1 grup varian"),
  productAddOns: array().of(
    object().shape({
      name: string().required("Harus diisi"),
      additionalPrice: number()
        .transform((value, originalValue) =>
          String(originalValue).trim() === "" ? undefined : value
        )
        .required("Harus diisi"),
    })
  ),
});
